module.exports = [{
      plugin: require('/Users/carlos.ramirezri/Sites/productos.baccredomatic.com/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-KHR5PZR","includeInDevelopment":false},
    },{
      plugin: require('/Users/carlos.ramirezri/Sites/productos.baccredomatic.com/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
